import React from 'lib/react';
import {
  EVGrid, EVSearchIcon, EVIconButton, EVClear, EVButton,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import Typography from 'commonComponents/typography';
import TextInputField from 'commonComponents/textInputField';
import { useDispatch, useSelector } from 'lib/redux';
import { SET_REPORT_ANALYTICS_FILTERS, SET_REPORT_ANALYTICS_SEARCH_TEXT } from 'constants/ActionTypes';
import { DATE_RANGES } from 'features/orderHistory/components/filters/commonComponents/dateRangeFilter/DateFilter.utils';
import AnalyticsDashboardStyles from '../../../AnalyticsDashboardStyles';
import DateFilter from './DateFilter.component';
import ProductsFilter from './ProductsFilter.component';

function ReportFiltersRow() {
  const { t } = useTranslation();
  const classes = AnalyticsDashboardStyles();
  const dispatch = useDispatch();

  const {
    searchText, selectedProduct, selectedDateOption, dateError,
  } = useSelector(({ analyticsDashboard }) => analyticsDashboard.reportAnalyticsFilters);
  const handleSearchInputChange = (event) => {
    dispatch({ type: SET_REPORT_ANALYTICS_SEARCH_TEXT, searchText: event.target.value });
  };

  const showResetButton = searchText?.length > 0 || selectedProduct || selectedDateOption !== DATE_RANGES.LAST_YEAR;
  const handleApplyFilters = () => dispatch({ type: SET_REPORT_ANALYTICS_FILTERS });

  const handleResetFilters = () => dispatch({ type: SET_REPORT_ANALYTICS_FILTERS, reset: true });
  return (
    <EVGrid className={classes.filtersRow}>
      <Typography variant="subtitle-400">
        {t('order_history__refine_results')}
      </Typography>
      <EVGrid className={classes.filtersSection}>
        <EVGrid className={classes.filtersContainer}>
          <EVGrid
            className={classes.searchSection}
          >
            <TextInputField
              inputId="search-input"
              inputFieldProps={{
                InputProps: {
                  endAdornment: <EVSearchIcon htmlColor="#B4BAC7" />,
                  classes: { root: classes.searchInput },
                  ...(searchText ? {
                    endAdornment: (
                      <EVIconButton
                        id="clear-search-btn"
                        onClick={() => dispatch({ type: SET_REPORT_ANALYTICS_SEARCH_TEXT, searchText: '' })}
                        style={{ padding: 0 }}
                      >
                        <EVClear htmlColor="#B4BAC7" />
                      </EVIconButton>
                    ),
                  } : {}),
                },
                placeholder: 'Search',
              }}
              startAdornment={<EVSearchIcon htmlColor="#B4BAC7" />}
              inputValue={searchText}
              handleChange={handleSearchInputChange}
            />
          </EVGrid>
          <ProductsFilter />
          <DateFilter />
        </EVGrid>
        <EVButton
          id="apply-filters"
          disabled={dateError}
          variant="outlined"
          color="primary"
          onClick={handleApplyFilters}
          style={{ height: '44px' }}
        >
          {t('finalize_order__order_summary__apply_promo_code')}
        </EVButton>
        <EVButton
          disabled={!showResetButton}
          id="reset-filters"
          color="primary"
          onClick={handleResetFilters}
          style={{ height: '44px' }}
        >
          {t('common__reset')}
        </EVButton>
      </EVGrid>
    </EVGrid>
  );
}

export default ReportFiltersRow;
